
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Job } from '@/types/Jobs'
import EditJobDialog from '@/views/jobs/EditJobDialog.vue'
import CloseJobDialog from '@/views/jobs/CloseJobDialog.vue'

@Component({
  components: {
    EditJobDialog,
    CloseJobDialog
  }
})
export default class JobsList extends Vue {
  
  @Prop(Array) readonly jobs!: Array<Job>

  editJobDialog = false
  closeJobDialog = false
  selectedJobId: number | null = null

  get jobsSorted() {
    return this.jobs.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
  }

  openEditJobDialog(jobId: number) {
    this.selectedJobId = jobId
    this.editJobDialog = true
  }

  openCloseJobDialog(jobId: number) {
    this.selectedJobId = jobId
    this.closeJobDialog = true
  }
}
